import React from "react";

// Icons
const deleteIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete.png`;
const deletehoverIcon = `${EASYCOMMERCE.assets}admin/img/icons/delete-hover.png`;
const editIcon = `${EASYCOMMERCE.assets}admin/img/icons/status-edit-icon.png`;

const ShippingPlans = ({
    shippingPlans,
    handleShippingEdit,
    handleDeleteShipping,
}) => {
    return (
        <>
            <div className="bg-white mt-8">
                <table className="w-full">
                    <thead>
                        <tr className="border-b border-ec-border">
                            <th className="w-[20%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                Plan
                            </th>
                            <th className="w-[10%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                Status
                            </th>
                            <th className="w-[35%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                Regions
                            </th>
                            <th className="w-[25%] text-left text-ec-placeholder font-inter font-medium text-base leading-[26px] py-6">
                                Methods
                            </th>
                            <th className="w-[10%]"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {shippingPlans.length > 0 &&
                            shippingPlans.map((shippingMethod, index) => (
                                <tr
                                    key={index}
                                    className={
                                        index < shippingPlans.length - 1
                                            ? "border-b border-ec-border"
                                            : ""
                                    }
                                >
                                    <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                        {shippingMethod.name}
                                    </td>
                                    <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                        <span className="flex justify-start items-center gap-3">
                                            <span
                                                className={`w-3 h-3 rounded-full ${
                                                    shippingMethod.active
                                                        ? "bg-[#00E91B]"
                                                        : "bg-[#cdcdcd]"
                                                }`}
                                            ></span>

                                            <span>
                                                {shippingMethod.active
                                                    ? "Active"
                                                    : "Deactive"}
                                            </span>
                                        </span>
                                    </td>
                                    <td className="py-6 font-inter text-base font-normal leading-[26px] text-ec-body">
                                        {shippingMethod.regions.map(
                                            (region, index) =>
                                                shippingMethod.regions.length -
                                                    1 ===
                                                index
                                                    ? region.region_code
                                                    : region.region_code + ", "
                                        )}
                                    </td>
                                    <td className="py-6">
                                        {shippingMethod.methods.map(
                                            (method, index) => (
                                                <span
                                                    key={index}
                                                    className="font-inter font-normal text-base leading-[26px] text-ec-body 
                                                    border border-ec-border py-[2px] px-[10px] mx-1 bg-[#F8F8F8] rounded-[4px]"
                                                >
                                                    {method.name}
                                                </span>
                                            )
                                        )}
                                    </td>
                                    <td className="flex w-[94px] py-6">
                                        <button
                                            className="w-10 h-8 bg-[#F8F8F8] mr-4 rounded-[4px] flex justify-center"
                                            onClick={() =>
                                                handleShippingEdit(
                                                    shippingMethod.id
                                                )
                                            }
                                        >
                                            <img
                                                className="h-8 w-8"
                                                src={editIcon}
                                                alt=""
                                            />
                                        </button>
                                        <button
                                            className="w-10 h-8 bg-[#F8F8F8] mr-4 rounded-[4px] 
                                            flex items-center justify-center group hover:bg-[#FF3A521A]"
                                            onClick={() =>
                                                handleDeleteShipping(
                                                    shippingMethod.id
                                                )
                                            }
                                        >
                                            <img
                                                className="w-[14px] h-[16px] block group-hover:hidden"
                                                src={deleteIcon}
                                                alt="delete-pricing"
                                            />
                                            <img
                                                className="w-[14px] h-[16px] hidden group-hover:block"
                                                src={deletehoverIcon}
                                                alt="delete-pricing"
                                            />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ShippingPlans;
